import { compose, defaultTo, head, is, join, juxt, path, pathOr, prop, tail, toLower } from 'ramda'

export const lowerFirstLetter = compose(join(''), juxt([compose(toLower, head), tail]), defaultTo(''))

export const parseEntitiesResult = (result, variables, queryName) => {
  if (!result) return

  const entities = pathOr([], ['data', lowerFirstLetter(queryName)], result)
  if (!entities) return undefined
  if (!!entities.map) return entities.map((item, index) => parseEntity(item, getInput(variables, index)))
  if (is(Object, entities)) return [parseEntity(entities, getInput(variables, 0))]
  return undefined
}

const getInput = (variables, index) => {
  const params = prop(index, variables)
  const paramsFromInputs = path(['inputs', index], variables)
  const paramsFromInput = prop('input', variables)
  return paramsFromInputs || paramsFromInput || params || variables
}

const parseEntity = (saved, input) => {
  return {
    model: lowerFirstLetter(saved.__typename),
    id: saved.id,
    name: saved.name || input.name
  }
}
